import * as Yup from 'yup';

export const initialForgetPassword = {
    email: "",
};
export const forgetPasswordValidation = Yup.object().shape({
    email: Yup.string()
        .email("Error: Enter a valid email address, for example mike@gmail.com")
        .required("Required"),
});